import React, { Fragment } from 'react';
import { SizeNotice } from '../../SizeGuide.css';
import { men as menData } from '../../SizeGuideData';
import { renderTable } from '../../size_guide_helpers';

const men = () => [
  { tab: 'tab_clothing', label: 'Clothing', contentGenerator: () => renderTable(menData.clothing) },
  { tab: 'tab_shirts', label: 'Shirts', contentGenerator: () => renderTable(menData.shirts) },
  {
    tab: 'tab_jeans',
    label: 'Jeans',
    contentGenerator: () => (
      <Fragment>
        {renderTable(menData.jeans.waist)}
        {renderTable(menData.jeans.length)}
      </Fragment>
    )
  },
  { tab: 'tab_shoes', label: 'Shoes', contentGenerator: () => renderTable(menData.shoes, 0, false) },
  {
    tab: 'tab_hats',
    label: 'Hats',
    contentGenerator: () => (
      <Fragment>
        {renderTable(menData.hats)}
        <SizeNotice>{menData.hats_notice}</SizeNotice>
      </Fragment>
    )
  },
  {
    tab: 'tab_gloves',
    label: 'Gloves',
    contentGenerator: () => (
      <Fragment>
        {renderTable(menData.gloves)}
        <SizeNotice>{menData.gloves_notice}</SizeNotice>
      </Fragment>
    )
  },
  { tab: 'tab_belts', label: 'Belts', contentGenerator: () => renderTable(menData.belts) },
  { tab: 'tab_rings', label: 'Rings', contentGenerator: () => renderTable(menData.rings) }
];

export default men;
